import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { environment } from 'environments/environment';
import { InquiryComponent } from './inquiry.app.component';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UploaderModule } from 'Shared/Uploader/uploader.module';
import { Angular2AirDatepickerModule } from 'Shared/components/calendar/angular2-air-datepicker.module';
import { PopupModule } from 'Shared/modules/popup/popup.module';
import { LinkSharedModule } from 'Shared/modules/shared-module/link-shared.module';
import { GridModule } from 'Shared/modules/grid/grid.module';
import { RecaptchaModule, RECAPTCHA_SETTINGS, RecaptchaSettings, RecaptchaLoaderService } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { LookupService } from 'Shared/services/lookup-service/lookup.service';
import { ResourceService } from 'Shared/services/resources-service/resource.service';
import { DocumentService } from 'Shared/services/Document-service/document-service';
import { InquiryService } from './inquiry.service';
import { PopupService } from 'Shared/modules/popup/popup.service';
import { CommonService } from 'Shared/services/common-service/common.service';
import { RecaptchaDynamicLanguageLoaderService } from 'Shared/services/Recaptcha/dynamic-language-loader.service';

@NgModule({
  declarations: [
    InquiryComponent
  ],
  imports: [
    BrowserModule,
    HttpModule,
    HttpClientModule,
    FormsModule,
    UploaderModule,
    ReactiveFormsModule,
    Angular2AirDatepickerModule,
    PopupModule,
    LinkSharedModule,
    GridModule,
    RecaptchaModule,
    RecaptchaFormsModule,
  ],
  providers: [LookupService,
    ResourceService,
    DocumentService,
    InquiryService,
    PopupService,
    CommonService,
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: environment.sitekeyCaptcha } as RecaptchaSettings,
    },
    {
      provide: RecaptchaLoaderService,
      useClass: RecaptchaDynamicLanguageLoaderService,
    }],
  bootstrap: [InquiryComponent]
})
export class InquiryModule { }
